import { useState, useMemo, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate,useLocation } from "react-router-dom";

import "./UpdatePatinet.css";
import "./PatientForm.css";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import {
  antenatalCheckUpsvalues,
  antenatalIllnessOptionValues,
  breastFeedingValues,
  criedAtBirthValues,
  gendersValue,
  hospitalizationValues,
  immunizationValue,
  injectionTetanusToxoidValues,
  ironValues,
  maternalEducationValues,
  modeOfDeliveryvalues,
  mothersNutritionValues,
  neonatalProblemsOptionValues,
  placeOfDeliveryValues,
  relationValues,
  resuscitationValues,
} from "./selectOptionValues";
import BasicDatePicker from "./Date-picker";
import CircularLoading from "../loading/Loading";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import {
  calculateAgeInMonths,
  caluclateAgeinDays,
  caluclateGestationalAgeInDays,
  getDateAndYear,
} from "../helper/getAge";
import { toast } from "react-toastify";
import dataCapitalization from "../util/dataCapitalization";
import NumberInput from "./ui/NumberInput";
import Loader from "./Loader";
import axios from "axios";
import { formatDate } from "../util/getFormattedDate";
import { useDoctorContext } from "../context/DoctorContext";
import { cleanEnglishOnly } from "../util/capitalize";
// import CircularLoading from "../loading/Loading";

const UpdatePatient = ({currentUser}) => {
  const { id, docId } = useParams();
  let navigate = useNavigate();
  const token = localStorage.getItem("s2stoken");

  const handleBack = () => {
    navigate(`/new-patient-profile/${id}/${docId}`);
  };
  const [patientData, setPatientData] = useState(null);
  const [caregiverData, setCaregiverData] = useState(null);
  const [gestationalAgeInDays, setGestationalAgeInDays] = useState("");
  const [gestationalAgeInMonths, setGestationalAgeInMonths] = useState("");
  const [childId, setChildId] = useState("");
  const location = useLocation();
  const updateFromInvitation = location.state?.updateFromInvitation || false;
  const {fetchData} = useDoctorContext()

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    // Fetch patient data using the id and docId
    const fetchPatientData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/get_patient_fully_details/${id}/${docId}`,
          {
            credentials: "include",
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        
        if (!response.ok || data.success === false) {
          throw new Error(data.message || "Failed to fetch data");
        }
        if (response.ok) {
          const actualAge = caluclateAgeinDays(data?.patient?.date_of_birth);
          const actualAgeInMonths = calculateAgeInMonths(
            data?.patient?.date_of_birth
          );
          const gestationalAgeInDays = caluclateGestationalAgeInDays(
            data?.patient?.date_of_birth,
            data?.patient?.edd
          );
          if (data?.patient?.edd) {
            const eddAgeIndays = caluclateAgeinDays(data?.patient?.edd);
            const diffWeeks = eddAgeIndays
              ? Math.round((eddAgeIndays - actualAge) / 7)
              : "";
            const gestWeeks = 40 + diffWeeks;
            const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
            const gestMonths = actualAgeInMonths - gestMonthsDiff;
            const gestationalAgeDays =
              getDateAndYear(data?.patient?.date_of_birth) ===
              getDateAndYear(data?.patient?.edd)
                ? actualAge
                : gestationalAgeInDays !== 0
                ? actualAge - gestationalAgeInDays
                : 0;
            if (gestWeeks < 37) {
              setGestationalAgeInDays(gestationalAgeDays);
              setGestationalAgeInMonths(gestMonths);
            } else if (gestWeeks <= 40) {
              setGestationalAgeInDays(gestationalAgeDays);
              setGestationalAgeInMonths(actualAgeInMonths);
            } else {
              setGestationalAgeInDays(actualAge);
              setGestationalAgeInMonths(actualAgeInMonths);
            }
          } else if (!data?.patient?.edd && data?.patient?.gestational_age) {
            const adjustedAgeDays =
              actualAge - Math.round((40 - data?.patient?.gestational_age) * 7);
            const gestMonthDiff = Math.floor((40 - birth?.gestationalAge) / 4);
            const adjustedAgeMonths = actualAgeInMonths - gestMonthDiff;
            if (data?.patient?.gestational_age < 37) {
              setGestationalAgeInDays(adjustedAgeDays);
              setGestationalAgeInMonths(adjustedAgeMonths);
            } else if (data?.patient?.gestational_age <= 40) {
              setGestationalAgeInDays(adjustedAgeDays);
              setGestationalAgeInMonths(actualAgeInMonths);
            } else {
              setGestationalAgeInDays(actualAge);
              setGestationalAgeInMonths(actualAgeInMonths);
            }
          }
          setPatientData(dataCapitalization(data.patient));
          console.log(
            "DOB fetched from Database " + data?.patient?.date_of_birth
          );
          setCaregiverData(dataCapitalization(data.caregiver));
          console.log("The pre fetched the data is :", data);
        } else {
          console.error("Failed to fetch patient data");
        }
      } catch (error) {
        if (error?.message === "Token has expired") {
          localStorage.removeItem("s2stoken");
          navigate("/");
        }
        console.error("Error fetching patient data:", error);
      }
    };

    fetchPatientData();
  }, [id, docId]);

  useEffect(() => {
    if (!patientData) return;

    const fetchChildFromPatient = async () => {
    const payload = {
      firstName: patientData.first_name,
      lastName: patientData.last_name,
      gender: patientData.gender,
      dob: formatDate(patientData.date_of_birth),
    };
    const fetchChildUrl = `${process.env.REACT_APP_BACKEND_URL}/api/get_patient_child_id`;
    const fetchChildoptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    };
    try {
      const response = await axios.post(
        fetchChildUrl,
        payload,
        fetchChildoptions
      );

      const child = response.data.data;
      setChildId(child.child_id);
      console.log(child, "child id fetched from patient");
    } catch (err) {
      if (err?.response?.data?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      console.log("Error Fetching child error : ", err);
    }
  };

    fetchChildFromPatient();
  }, [patientData]);

  // const formatDate = (dateString) => {
  //   const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  //   return new Date(dateString).toLocaleDateString("en-CA", options);
  // };


  const transformAntenatalIllness = (illnessArray) => {
    if (
      illnessArray === undefined ||
      illnessArray === null ||
      illnessArray.length === 0
    ) {
      return [];
    }

    return illnessArray
      .filter((illness) => illness) // Filter out any empty values
      .map((illness) => ({
        value: illness,
        label:
          illness.charAt(0).toUpperCase() +
          illness.slice(1).toLowerCase().replace(/_/g, "/"),
      }));
  };

  const PATIENTFORM = {
    CAREGIVER: 0,
    PATIENT: 1,
    MATERNAL: 2,
    ANTENATAL: 3,
    BIRTH: 4,
    NEONATAL: 5,
    FAMILY: 6,
    FEEDING: 7,
    PRESENT: 8,
  };

  const CAREGIVERSTATE = useMemo(
    () => ({
      caregiverFirstName: caregiverData?.first_name || "",
      caregiverLastName: caregiverData?.last_name || "",
      relationship: caregiverData?.relationship || "",
      phoneNumber: caregiverData?.phone_number || "",
      email: caregiverData?.email || "",
      address: caregiverData?.address || "",
    }),
    [caregiverData]
  );

  const PATIENTSTATE = useMemo(
    () => ({
      patientFirstName: patientData?.first_name || "",
      patientMiddleName: patientData?.middle_name || "",
      patientLastName: patientData?.last_name || "",
      dateOfBirth: patientData?.date_of_birth || "",
      gender: patientData?.gender || "",
    }),
    [
      patientData?.gender,
      patientData?.date_of_birth,
      patientData?.first_name,
      patientData?.last_name,
      patientData?.middle_name,
    ]
  );

  // console.table("The patient is :", patientData);

  const MATERNALSTATE = useMemo(
    () => ({
      maternalAge: patientData?.mother_age || "",
      education: patientData?.education || "",
      numberOfChildren: patientData?.number_of_children || "",
    }),
    [
      patientData?.education,
      patientData?.mother_age,
      patientData?.number_of_children,
    ]
  );

  const ANTENATALSTATE = useMemo(
    () => ({
      mothersNutrition: patientData?.nutrition || "",
      antenatalCheckUps: patientData?.antenatal_checkups || "",
      iron: patientData?.iron || "",
      injectionTetanusToxoid: patientData?.injection_tetanus_toxoid || "",
      antenatalIllness: patientData?.antenatal_illness || [],
      // edd: formatDate(patientData?.edd),
      edd: patientData?.edd,
    }),
    [
      patientData?.antenatal_checkups,
      patientData?.antenatal_illness,
      patientData?.edd,
      patientData?.injection_tetanus_toxoid,
      patientData?.iron,
      patientData?.nutrition,
    ]
  );

  const BIRTHSTATE = useMemo(
    () => ({
      placeOfDelivery: patientData?.place_of_delivery || "",
      modeOfDelivery: patientData?.mode_of_delivery || "",
      criedAtBirth: patientData?.cried_at_birth || "",
      resuscitation: patientData?.resuscitation || [],
      congenitalAnomaly: patientData?.congenital_anomaly || "",
      birthTrauma: patientData?.birth_trauma || "",
      others: patientData?.other || "",
      birthWeight: patientData?.birth_weight || "",
      birthLength: patientData?.birth_length || "",
      birthHeadCircumference: patientData?.birth_head_circumference || null,
      gestationalAge: patientData?.gestational_age || "",
    }),
    [
      patientData?.birth_head_circumference,
      patientData?.birth_length,
      patientData?.birth_trauma,
      patientData?.birth_weight,
      patientData?.congenital_anomaly,
      patientData?.cried_at_birth,
      patientData?.gestational_age,
      patientData?.mode_of_delivery,
      patientData?.other,
      patientData?.place_of_delivery,
      patientData?.resuscitation,
    ]
  );

  const NEONATALSTATE = useMemo(
    () => ({
      neonatalProblems: patientData?.neonatal_problems || [],
      hospitalization: patientData?.hospitalization || "",
    }),
    [patientData?.hospitalization, patientData?.neonatal_problems]
  );
  const PRESENTSTATE = useMemo(
    () => ({
      presentNutrition: patientData?.nutrition || "",
      immunization: patientData?.immunization || "",
      chronicIllness: patientData?.chronic_illness || "",
      growthFaltering: patientData?.growth_faltering || "",
      delayedDevelopmentMotor: patientData?.delayed_development_motor || "",
      delayedDevelopmentCognitive:
        patientData?.delayed_development_cognitive || "",
      delayedDevelopmentLanguage:
        patientData?.delayed_development_language || "",
      atypicalBehaviour: patientData?.atypical_behaviour || "",
      convulsions: patientData?.convulsions || "",
      dysmorphism: patientData?.dysmorphism || "",
      anySystemicIllness: patientData?.any_systemic_illness || "",
      currentAge:
        calculateAgeInMonths(patientData?.date_of_birth) ||
        // calculateAgeInMonths(getFormattedDate(patientData?.date_of_birth)) ||
        "",
      currentWeight: patientData?.cur_weight || "",
      currentLength: patientData?.cur_length || "",
      currentHeadCircumference: patientData?.cur_head_circumference || "",
      presentOthers: patientData?.present_others || "",
      presentAgeInDays: caluclateAgeinDays(patientData?.date_of_birth) || "",
      gestationalAgeInMonths: Number(gestationalAgeInMonths) || "",
      gestationalAgeInDays: Number(gestationalAgeInDays) || "",
    }),
    [
      patientData?.any_systemic_illness,
      patientData?.atypical_behaviour,
      patientData?.chronic_illness,
      patientData?.convulsions,
      // patientData?.cur_age,
      patientData?.cur_head_circumference,
      patientData?.cur_length,
      patientData?.cur_weight,
      patientData?.delayed_development_cognitive,
      patientData?.delayed_development_language,
      patientData?.delayed_development_motor,
      patientData?.dysmorphism,
      patientData?.growth_faltering,
      patientData?.immunization,
      patientData?.nutrition,
      patientData?.present_others,
      patientData?.date_of_birth,
      gestationalAgeInMonths,
      gestationalAgeInDays,
    ]
  );

  const TOGGLESTATE = useMemo(
    () => ({
      isCongenitalAnomaly:
        patientData?.congenital_anomaly &&
        patientData?.congenital_anomaly.toLowerCase() !== "no"
          ? true
          : false,
      chronicIllness:
        patientData?.chronic_illness &&
        patientData?.chronic_illness.toLowerCase() !== "no"
          ? true
          : false,
      growthFaltering:
        patientData?.growth_faltering &&
        patientData?.growth_faltering.toLowerCase() !== "no"
          ? true
          : false,
      delayedDevelopmentMotor:
        patientData?.delayed_development_motor &&
        patientData?.delayed_development_motor.toLowerCase() !== "no"
          ? true
          : false,
      delayedDevelopmentCognitiveSocial:
        patientData?.delayed_development_cognitive &&
        patientData?.delayed_development_cognitive.toLowerCase() !== "no"
          ? true
          : false,
      delayedDevelopmentLanguage:
        patientData?.delayed_development_language &&
        patientData?.delayed_development_language.toLowerCase() !== "no"
          ? true
          : false,
      atypicalBehaviour:
        patientData?.atypical_behaviour &&
        patientData?.atypical_behaviour.toLowerCase() !== "no"
          ? true
          : false,
      dysmorphism:
        patientData?.dysmorphism &&
        patientData?.dysmorphism.toLowerCase() !== "no"
          ? true
          : false,
      anySystemicIllness:
        patientData?.any_systemic_illness &&
        patientData?.any_systemic_illness.toLowerCase() !== "no"
          ? true
          : false,
      anyHistoryofIllness:
        patientData?.any_history_of_illness &&
        patientData?.any_history_of_illness.toLowerCase() !== "no"
          ? true
          : false,
      disabilityInTheFamily:
        patientData?.disability_in_the_family &&
        patientData?.disability_in_the_family.toLowerCase() !== "no"
          ? true
          : false,
      anyBehaviouralProblem:
        patientData?.any_behavioural_problem &&
        patientData?.any_behavioural_problem.toLowerCase() !== "no"
          ? true
          : false,
      birthTrauma:
        patientData?.birth_trauma &&
        patientData?.birth_trauma.toLowerCase() !== "no"
          ? true
          : false,
    }),
    [patientData]
  );

  const FAMILYSTATE = useMemo(
    () => ({
      anyHistoryofIllness: patientData?.any_history_of_illness || "",
      disabilityInTheFamily: patientData?.disability_in_the_family || "",
      anyBehaviouralProblem: patientData?.any_behavioural_problem || "",
    }),
    [
      patientData?.any_behavioural_problem,
      patientData?.any_history_of_illness,
      patientData?.disability_in_the_family,
    ]
  );

  const FEEDINGSTATE = useMemo(
    () => ({
      breastFeeding: patientData?.breast_feeding || "",
      noOfFeeds: patientData?.no_of_feeds || "",
      solidFood: patientData?.solid_food || "",
    }),
    [
      patientData?.breast_feeding,
      patientData?.no_of_feeds,
      patientData?.solid_food,
    ]
  );

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  useEffect(() => {
    setCaregiver(CAREGIVERSTATE);
    setPatient(PATIENTSTATE);
    setBirth(BIRTHSTATE);
    setMaternal(MATERNALSTATE);
    setAntenatal(ANTENATALSTATE);
    setPresent(PRESENTSTATE);
    setFamily(FAMILYSTATE);
    setFeeding(FEEDINGSTATE);
    setToggle(TOGGLESTATE);
    setNeonatal(NEONATALSTATE);
  }, [
    ANTENATALSTATE,
    BIRTHSTATE,
    CAREGIVERSTATE,
    FAMILYSTATE,
    FEEDINGSTATE,
    MATERNALSTATE,
    NEONATALSTATE,
    PATIENTSTATE,
    PRESENTSTATE,
    TOGGLESTATE,
    caregiverData,
    patientData,
  ]);

  const [step, setStep] = useState(PATIENTFORM.CAREGIVER);
  const [cargiver, setCaregiver] = useState(CAREGIVERSTATE);
  const [patient, setPatient] = useState(PATIENTSTATE);
  const [maternal, setMaternal] = useState(MATERNALSTATE);
  const [antenatal, setAntenatal] = useState(ANTENATALSTATE);
  const [birth, setBirth] = useState(BIRTHSTATE);
  const [neontal, setNeonatal] = useState(NEONATALSTATE);
  const [present, setPresent] = useState(PRESENTSTATE);
  const [family, setFamily] = useState(FAMILYSTATE);
  const [feeding, setFeeding] = useState(FEEDINGSTATE);
  const [toggle, setToggle] = useState(TOGGLESTATE);
  const [loading, setLoading] = useState(false);

  const actionLabel = useMemo(() => {
    if (step === PATIENTFORM.PRESENT) {
      return "Update Patient";
    }
    return "Next";
  }, [PATIENTFORM.PRESENT, step]);

  const secondaryActionLabel = useMemo(() => {
    if (step === PATIENTFORM.CAREGIVER) {
      return undefined;
    }
    return "Back";
  }, [PATIENTFORM.CAREGIVER, step]);

  useEffect(() => {
    const gestationalWeeks = birth.gestationalAge;
    const actualAgeInDays = caluclateAgeinDays(patient.dateOfBirth);
    console.log("birth change " + actualAgeInDays);
    const adjustedAgeDays =
      actualAgeInDays - Math.round((40 - Number(gestationalWeeks)) * 7);
    console.log("use effect called");
    if (!antenatal?.edd && present.currentAge <= 24) {
      if (gestationalWeeks === "" || gestationalWeeks === null) {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      } else if (gestationalWeeks < 37) {
        const gestMonthsDiff = Math.floor((40 - gestationalWeeks) / 4);
        const gestMonths =
          calculateAgeInMonths(patient.dateOfBirth) - gestMonthsDiff;
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: gestMonths,
          gestationalAgeInDays: adjustedAgeDays,
        }));
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: present.currentAge,
          gestationalAgeInDays: actualAgeInDays,
        }));
      }
    }
  }, [birth.gestationalAge]);

  if (!patientData || !caregiverData) {
    return <CircularLoading />;
  }

  // Handle date change for Date Picker
  const handleDateChange = (date) => {
    setPatient((prevData) => ({
      ...prevData,
      dateOfBirth: date,
    }));
    const actualAge = caluclateAgeinDays(date);
    const actualAgeInMonths = calculateAgeInMonths(date);
    const calculateAgeInDays = caluclateGestationalAgeInDays(
      date,
      antenatal?.edd
    );
    const gestationalAgeInDays =
      getDateAndYear(date) === getDateAndYear(antenatal?.edd)
        ? actualAge
        : calculateAgeInDays !== 0
        ? actualAge - calculateAgeInDays
        : 0;

    if (antenatal.edd) {
      console.log("edd called");
      const eddAgeIndays = caluclateAgeinDays(antenatal.edd);
      const diffWeeks = Math.round((eddAgeIndays - actualAge) / 7);
      const gestWeeks = 40 + diffWeeks;
      setBirth((prev) => ({
        ...prev,
        gestationalAge: gestWeeks,
      }));
      if (actualAgeInMonths <= 24) {
        if (gestWeeks < 37) {
          const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
          const gestMonths = actualAgeInMonths - gestMonthsDiff;
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: gestMonths,
            gestationalAgeInDays: gestationalAgeInDays,
          }));
        } else {
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: actualAgeInMonths,
            gestationalAgeInDays: actualAge,
          }));
        }
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      }
    }
    if (!antenatal?.edd && birth?.gestationalAge) {
      console.log(" gestational called");
      const gestMonthDiff = Math.floor((40 - birth?.gestationalAge) / 4);
      const adjustedAgeMonths = actualAgeInMonths - gestMonthDiff;
      const adjustedAgeDays = actualAge - (40 - birth?.gestationalAge) * 7;
      if (actualAgeInMonths <= 24) {
        if (birth.gestationalAge < 37) {
          console.log(
            "calculated adjusted months new fomula",
            adjustedAgeMonths
          );
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: adjustedAgeMonths,
            gestationalAgeInDays: adjustedAgeDays,
          }));
        } else {
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: actualAgeInMonths,
            gestationalAgeInDays: actualAge,
          }));
        }
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      }
    }
    if (actualAgeInMonths === 0) {
      return setPresent((prevDt) => ({
        ...prevDt,
        presentAgeInDays: actualAge,
        currentAge: actualAgeInMonths,
      }));
    }
    setPresent((prevDt) => ({
      ...prevDt,
      currentAge: actualAgeInMonths,
    }));
  };

  const handleEddDateChange = (date) => {
    const actualAge = caluclateAgeinDays(patient.dateOfBirth);
    const actualAgeInMonths = calculateAgeInMonths(patient.dateOfBirth);

    const calculateAgeInDays = caluclateGestationalAgeInDays(
      patient.dateOfBirth,
      date
    );

    const gestationalAgeInDays =
      getDateAndYear(date) === getDateAndYear(patient?.dateOfBirth)
        ? actualAge
        : calculateAgeInDays !== 0
        ? actualAge - calculateAgeInDays
        : 0;
    if (date) {
      const eddAgeIndays = caluclateAgeinDays(date);
      console.log("edd age in days", eddAgeIndays);
      console.log("dob age in days", actualAge);
      const diffWeeks = eddAgeIndays
        ? Math.round((eddAgeIndays - actualAge) / 7)
        : "";
      const gestWeeks = 40 + diffWeeks;
      console.log("diffweeks", diffWeeks);
      console.log("gestweeks", gestWeeks);
      setBirth((prev) => ({
        ...prev,
        gestationalAge: gestWeeks,
      }));
      if (present.currentAge <= 24) {
        if (gestWeeks < 37) {
          const gestMonthsDiff = Math.floor((40 - gestWeeks) / 4);
          const gestMonths = actualAgeInMonths - gestMonthsDiff;
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: gestMonths,
            gestationalAgeInDays: gestationalAgeInDays,
          }));
        } else {
          setPresent((prev) => ({
            ...prev,
            gestationalAgeInMonths: present.currentAge,
            gestationalAgeInDays: actualAge,
          }));
        }
      } else {
        setPresent((prev) => ({
          ...prev,
          gestationalAgeInMonths: "",
          gestationalAgeInDays: "",
        }));
      }
    } else {
      setBirth((prev) => ({
        ...prev,
        gestationalAge: "",
      }));
      setPresent((prev) => ({
        ...prev,
        gestationalAgeInMonths: "",
        gestationalAgeInDays: "",
      }));
    }

    setAntenatal((prevData) => ({
      ...prevData,
      edd: date,
    }));
  };
  console.log(present);
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zAZ0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
  };
  const validateCaregiverFields = () => {
    return (
      cargiver.caregiverFirstName &&
      cargiver.caregiverLastName &&
      cargiver.relationship &&
      cargiver.phoneNumber &&
      cargiver.address
    );
  };
  const validatePatientFields = () => {
    return (
      patient.patientFirstName &&
      patient.patientLastName &&
      patient.gender &&
      patient.dateOfBirth
    );
  };
  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\+?[0-9]{7,15}$/;
    return phoneRegex.test(phone);
  };

  const handleCaregiverChange = (e) => {
    if (e.target.name === "phoneNumber" && isNaN(e.target.value)) {
      return toast.warn("Phone number must be a positive integer");
    }
    if (e.target.name === "email") {
      setCaregiver({
        ...cargiver,
        [e.target.name]: e.target.value.toLowerCase().trim(),
      });
    } else if (e.target.name === "address") {
      setCaregiver({ ...cargiver, [e.target.name]: cleanEnglishOnly(e.target.value) });
    } else {
      setCaregiver({ ...cargiver, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
    }
    // setCaregiver({ ...cargiver, [e.target.name]: e.target.value.trim() });
  };

  const handlePatientChange = (e) => {
    setPatient({ ...patient, [e.target.name]: cleanEnglishOnly(e.target.value) });
  };

  const handleMaternalChange = (e) => {
    if (e.target.name === "maternalAge" && isNaN(e.target.value)) {
      return toast.warn("Mother age must be a positive integer");
    }
    if (e.target.name === "numberOfChildren" && isNaN(e.target.value)) {
      return toast.warn("Number of children must be a positive integer");
    }
    setMaternal({ ...maternal, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleAntenatalChange = (e) => {
    setAntenatal({ ...antenatal, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleBirthChange = (e) => {
    if (e.target.name === "birthWeight" && isNaN(e.target.value)) {
      return toast.warn(`Birth weight must be a positive integer`);
    }
    if (e.target.name === "birthLength" && isNaN(e.target.value)) {
      return toast.warn(`Birth length must be a positive integer`);
    }
    if (e.target.name === "birthHeadCircumference" && isNaN(e.target.value)) {
      return toast.warn(`Birth head circumference must be a positive integer`);
    }
    if (e.target.name === "gestationalAge" && isNaN(e.target.value)) {
      return toast.warn(`Gestational age must be a positive integer`);
    }
    if (e.target.name === "others") {
      return setBirth({ ...birth, [e.target.name]: cleanEnglishOnly(e.target.value) });
    }
    setBirth({ ...birth, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleNeonatalChange = (e) => {
    setNeonatal({ ...neontal, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleFamilyChange = (e) => {
    setFamily({ ...family, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleFeedingChange = (e) => {
    if (e.target.name === "noOfFeeds" && isNaN(e.target.value)) {
      return toast.warn(`Number of feeds must be a positive integer`);
    }
    setFeeding({ ...feeding, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handlePresentChange = (e) => {
    if (e.target.name === "currentAge" && isNaN(e.target.value)) {
      return toast.warn(`Current age must be a positive integer`);
    }
    if (e.target.name === "currentWeight" && isNaN(e.target.value)) {
      return toast.warn(`Current Weight must be a positive integer`);
    }
    if (e.target.name === "currentLength" && isNaN(e.target.value)) {
      return toast.warn(`Current length must be a positive integer`);
    }
    if (e.target.name === "currentHeadCircumference" && isNaN(e.target.value)) {
      return toast.warn(
        `Current head circumference must be a positive integer`
      );
    }
    if (
      e.target.name === "presentOthers" ||
      e.target.name === "atypicalBehaviour"
    ) {
      return setPresent({ ...present, [e.target.name]: cleanEnglishOnly(e.target.value) });
    }
    setPresent({ ...present, [e.target.name]: cleanEnglishOnly(e.target.value).trim() });
  };

  const handleToggleChange = (e, field) => {
    const { value } = e.target;
    setToggle((prevToggle) => ({
      ...prevToggle,
      [field]: value === "yes",
    }));
    if (value !== "yes") {
      handlePresentChange(e);
    }
  };

  const incrementStep = () => {
    if (
      step === PATIENTFORM.CAREGIVER &&
      cargiver?.email &&
      !validateEmail(cargiver.email)
    ) {
      return toast.warn("Please enter a valid email address");
    }
    if (step === PATIENTFORM.CAREGIVER && !validateCaregiverFields()) {
      return toast.warn("Please fill all required fields.");
    }
    if (
      step === PATIENTFORM.CAREGIVER &&
      !validatePhoneNumber(cargiver.phoneNumber)
    ) {
      return toast.warn("Please enter a valid phone number.");
    }
    if (step === PATIENTFORM.PATIENT && !validatePatientFields()) {
      return toast.warn("Please fill all required fields.");
    }
    if (
      step === PATIENTFORM.BIRTH &&
      toggle.isCongenitalAnomaly &&
      birth.congenitalAnomaly.trim() === ""
    ) {
      return toast.warn("Please specify congenital anomaly");
    }
    if (
      step === PATIENTFORM.BIRTH &&
      toggle.birthTrauma &&
      birth.birthTrauma.trim() === ""
    ) {
      return toast.warn("Please specify birth trauma");
    }
    if (
      step === PATIENTFORM.FAMILY &&
      toggle.anyHistoryofIllness &&
      family.anyHistoryofIllness.trim() === ""
    ) {
      return toast.warn("Please specify any history of illness or death");
    }
    if (
      step === PATIENTFORM.FAMILY &&
      toggle.anyBehaviouralProblem &&
      family.anyBehaviouralProblem.trim() === ""
    ) {
      return toast.warn("Please specify  any behavioural problem in family");
    }
    if (
      step === PATIENTFORM.FAMILY &&
      toggle.disabilityInTheFamily &&
      family.disabilityInTheFamily.trim() === ""
    ) {
      return toast.warn("Please specify disability in family");
    }
    if (step === PATIENTFORM.PRESENT) {
      if (toggle.chronicIllness && present.chronicIllness.trim() === "") {
        return toast.warn("Please specify chronic illness");
      }
      if (toggle.growthFaltering && present.growthFaltering.trim() === "") {
        return toast.warn("Please specify growth faltering");
      }
      if (
        toggle.delayedDevelopmentCognitiveSocial &&
        present.delayedDevelopmentCognitive.trim() === ""
      ) {
        return toast.warn("Please specify delayed development cognitive");
      }
      if (
        toggle.delayedDevelopmentMotor &&
        present.delayedDevelopmentMotor.trim() === ""
      ) {
        return toast.warn("Please specify delayed development motor");
      }
      if (
        toggle.delayedDevelopmentLanguage &&
        present.delayedDevelopmentLanguage.trim() === ""
      ) {
        return toast.warn("Please specify delayed development language");
      }
      if (toggle.atypicalBehaviour && present.atypicalBehaviour.trim() === "") {
        return toast.warn("Please specify atypical behaviour");
      }
      if (toggle.dysmorphism && present.dysmorphism.trim() === "") {
        return toast.warn("Please specify dysmorphism");
      }
      if (
        toggle.anySystemicIllness &&
        present.anySystemicIllness.trim() === ""
      ) {
        return toast.warn("Please specify systemic illness");
      }
      handleSubmit();
    }
    setStep((prevStep) => {
      const nextStep = Math.min(PATIENTFORM.PRESENT, prevStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return nextStep;
    });
  };

  const decrementStep = () => {
    setStep((prevStep) => {
      const prev = Math.max(PATIENTFORM.CAREGIVER, prevStep - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return prev;
    });
  };

  const handleSubmit = async () => {
    const date = new Date(patient.dateOfBirth);
    const formattedDate = date.toLocaleDateString("en-CA");

    const eddDate = antenatal.edd ? new Date(antenatal.edd) : null;

    const formattedEddDate = eddDate ? eddDate.toLocaleDateString("en-CA") : "";

    const patientData = {
      pediatricianId: docId,
      patientId: id,
      childId: childId,
      caregiver_first_name: cargiver.caregiverFirstName.toLowerCase().trim() ?? "",
      caregiver_last_name: cargiver.caregiverLastName.toLowerCase().trim() ?? "", 
      phone_number: cargiver.phoneNumber ?? "",
      relationship: cargiver.relationship ?? "",
      email: cargiver.email ? cargiver.email.toLowerCase().trim() : "",
      address: cargiver.address ?? "",
      first_name: patient.patientFirstName.toLowerCase().trim() ?? "",
      last_name: patient.patientLastName.toLowerCase().trim() ?? "",
      middle_name: patient.patientMiddleName ?? "",
      gender: patient.gender ?? "",
      date_of_birth: formattedDate,
      birth_weight: birth.birthWeight ?? "",
      birth_length: birth.birthLength ?? "",
      birth_head_circumference: birth.birthHeadCircumference ?? null,
      cur_age: present.currentAge ? present.currentAge : 0,
      age_days: present.presentAgeInDays ?? "",
      cur_weight: present.currentWeight ?? "",
      cur_length: present.currentLength ?? "",
      gestational_age_in_months: present?.gestationalAgeInMonths || "",
      gestational_age_in_days: present?.gestationalAgeInDays || "",
      cur_head_circumference: present.currentHeadCircumference ?? "",
      gestational_age: birth.gestationalAge ?? "",
      mother_age: maternal.maternalAge ?? "",
      education: maternal.education,
      number_of_children: maternal.numberOfChildren ?? "",
      nutrition: antenatal.mothersNutrition,
      antenatal_checkups: antenatal.antenatalCheckUps,
      iron: antenatal.iron,
      injection_tetanus_toxoid: antenatal.injectionTetanusToxoid,
      antenatal_illness: antenatal.antenatalIllness,
      edd: formattedEddDate,
      place_of_delivery: birth.placeOfDelivery,
      mode_of_delivery: birth.modeOfDelivery,
      cried_at_birth: birth.criedAtBirth,
      resuscitation: birth.resuscitation,
      congenital_anomaly: birth.congenitalAnomaly,
      birth_trauma: birth.birthTrauma,
      other: birth.others,
      neonatal_problems: neontal.neonatalProblems,
      hospitalization: neontal.hospitalization,
      any_history_of_illness: family.anyHistoryofIllness,
      disability_in_the_family: family.disabilityInTheFamily,
      any_behavioural_problem: family.anyBehaviouralProblem,
      breast_feeding: feeding.breastFeeding,
      solid_food: feeding.solidFood,
      no_of_feeds: feeding.noOfFeeds,
      immunization: present.immunization,
      chronic_illness: present.chronicIllness,
      growth_faltering: present.growthFaltering,
      delayed_development_motor: present.delayedDevelopmentMotor,
      delayed_development_cognitive: present.delayedDevelopmentCognitive,
      delayed_development_language: present.delayedDevelopmentLanguage,
      atypical_behaviour: present.atypicalBehaviour,
      convulsions: present.convulsions,
      dysmorphism: present.dysmorphism,
      any_systemic_illness: present.anySystemicIllness,
      present_others: present.presentOthers,
    };
    console.log(patientData,'update patient payload');
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/update_patient_by_doctor`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(patientData),
        }
      );
      const data = await response.json();
      if (!response.ok || data?.status === "error") {
        throw new Error(data?.message || "Failed to update patient");
      }
      if (response.ok) {
        if (updateFromInvitation) {
          fetchData(currentUser)
        }
        setLoading(false);
        toast.success("Patient updated successfully");
      } else {
        setLoading(false);
        toast.error(data?.message || "Update failed");
      }

      console.log(data);
      console.log(patientData);
    } catch (error) {
      setLoading(false);
      if (error?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      console.error("Patient update failed:", error);
      toast.error("Patient update failed please try again");
    } finally {
      setLoading(false);
      handleBack();
    }
  };

  let bodyContent = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Caregiver / Parent Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          name="caregiverFirstName"
          type="text"
          size="small"
          label="Caregiver First Name"
          value={cargiver.caregiverFirstName}
          onChange={handleCaregiverChange}
          not
          required
        />

        <TextField
          name="caregiverLastName"
          type="text"
          size="small"
          label="Caregiver Last Name"
          value={cargiver.caregiverLastName}
          onChange={handleCaregiverChange}
          not
          required
        />
        <TextField
          select
          name={"relationship"}
          label="Relationship"
          type={"text"}
          size="small"
          value={cargiver.relationship}
          onChange={handleCaregiverChange}
          required
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {relationValues.map((value) => (
            <MenuItem value={value}>{value}</MenuItem>
          ))}
        </TextField>
      </div>
      <div className={"caregiverDiveder"}>
        <TextField
          name={"email"}
          type={"text"}
          size="small"
          value={cargiver.email}
          label={"Email"}
          onChange={handleCaregiverChange}
          not
        />

        <NumberInput
          name={"phoneNumber"}
          value={cargiver.phoneNumber}
          label={"Phone Number"}
          onChange={handleCaregiverChange}
          required
        />
        <TextField
          name={"address"}
          type="text"
          size="small"
          value={cargiver.address}
          label={"Address"}
          onChange={handleCaregiverChange}
          not
          required
        />
      </div>
    </div>
  );

  let patientForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Patient Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          name={"patientFirstName"}
          value={patient.patientFirstName}
          type={"text"}
          size="small"
          label={"Patient First Name"}
          onChange={handlePatientChange}
          required
        />
        <TextField
          name={"patientMiddleName"}
          value={patient.patientMiddleName}
          type={"text"}
          size="small"
          label={"Patient Middle Name"}
          className={"requiredLabel"}
          onChange={handlePatientChange}
        />

        <TextField
          name={"patientLastName"}
          type={"text"}
          size="small"
          value={patient.patientLastName}
          label={"Patient Last Name"}
          className={"requiredLabel"}
          onChange={handlePatientChange}
          required
        />
        {/* <div className="calender"> */}
        <BasicDatePicker
          label={"Date Of Birth"}
          value={dayjs(patient.dateOfBirth)}
          onChange={handleDateChange}
          required
          maxDate
        />
        {/* {patient.dateOfBirth && <span
            className="clear-calender"
            onClick={() =>
              setPatient((prev) => ({ ...prev, dateOfBirth: null }))
            }
          >
            X
          </span>}
        </div> */}
        <TextField
          type={"text"}
          size="small"
          select
          name={"gender"}
          label="Gender"
          required
          onChange={handlePatientChange}
          value={patient.gender}
          sx={{
            fontSize: "14px",
            height: "40px",
            backgroundColor: "#3071FF21",
          }}
        >
          {gendersValue.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );

  let maternalForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Maternal Information</h2>
      <div className={"caregiverDiveder"}>
        <NumberInput
          name={"maternalAge"}
          label={"Mother Age"}
          value={maternal.maternalAge}
          onChange={handleMaternalChange}
        />
        <TextField
          type={"text"}
          select
          size="small"
          name={"education"}
          label={"Mother Education"}
          onChange={handleMaternalChange}
          value={maternal.education}
          sx={{ backgroundColor: "#3071FF21" }}
        >
          {maternalEducationValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <NumberInput
          name={"numberOfChildren"}
          label={"Number Of Children "}
          value={maternal.numberOfChildren}
          onChange={handleMaternalChange}
        />
      </div>
    </div>
  );

  let antenatalForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Antenatal Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          type={"text"}
          select
          size="small"
          label={"Mother Nutrition "}
          name={"mothersNutrition"}
          onChange={handleAntenatalChange}
          value={antenatal.mothersNutrition}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {mothersNutritionValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type={"text"}
          name={"antenatalCheckUps"}
          size="small"
          select
          label={"Antenatal CheckUps"}
          onChange={handleAntenatalChange}
          value={antenatal.antenatalCheckUps}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {antenatalCheckUpsvalues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type={"text"}
          name={"iron"}
          select
          size="small"
          label={"Iron or Folic Acid "}
          onChange={handleAntenatalChange}
          value={antenatal.iron}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {ironValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          type={"text"}
          select
          size="small"
          name={"injectionTetanusToxoid"}
          onChange={handleAntenatalChange}
          value={antenatal.injectionTetanusToxoid}
          label={"Injection Tetanus Toxoid"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {injectionTetanusToxoidValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {/* value not showing after selection */}
        {/* <TextField
          type={"text"}
          select
          size="small"
          name={"antenatalIllness"}
          label={"Antenatal Illness"}
          onChange={(values) => {
            setAntenatal((prevAntenatal) => ({
              ...prevAntenatal,
              antenatalIllness: values,
            }));
          }}
          value={antenatal.antenatalIllness}
          isMultipleSelect
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {antenatalIllnessOptionValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField> */}
        <FormControl
          size="small"
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          <InputLabel id="tone">Antenatal Illness</InputLabel>
          <Select
            labelId="responsive-care-giving-label"
            id="responsive-car-giving"
            multiple
            value={antenatal.antenatalIllness}
            onChange={(e) => {
              setAntenatal((prev) => ({
                ...prev,
                antenatalIllness: e.target.value,
              }));
            }}
            input={<OutlinedInput label="Antenatal Illness" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {antenatalIllnessOptionValues.map((name) => (
              <MenuItem key={name} value={name} sx={{ width: 400 }}>
                <Checkbox checked={antenatal.antenatalIllness.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className="calender">
          <BasicDatePicker
            value={
              antenatal.edd && antenatal.edd !== null
                ? dayjs(antenatal.edd)
                : null
            }
            label={"Expected Date of Delivery"}
            onChange={handleEddDateChange}
          />
          {antenatal?.edd && (
            <span
              className="clear-calender"
              onClick={() => setAntenatal((prev) => ({ ...prev, edd: null }))}
            >
              X
            </span>
          )}
        </div>
      </div>
    </div>
  );

  let birthForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Birth Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          type={"text"}
          select
          size="small"
          name={"placeOfDelivery"}
          onChange={handleBirthChange}
          label={"Place Of Delivery"}
          value={birth.placeOfDelivery}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {placeOfDeliveryValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label={"Mode Of Delivery"}
          size="small"
          select
          type={"text"}
          name={"modeOfDelivery"}
          onChange={handleBirthChange}
          value={birth.modeOfDelivery}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {modeOfDeliveryvalues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label={"Cried At Birth"}
          type={"text"}
          select
          size="small"
          name={"criedAtBirth"}
          onChange={handleBirthChange}
          value={birth.criedAtBirth}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {criedAtBirthValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <FormControl
          size="small"
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          <InputLabel id="tone">Resuscitation</InputLabel>
          <Select
            labelId="Resuscitation"
            id="Resuscitation"
            multiple
            value={birth.resuscitation}
            onChange={(e) => {
              setBirth((prev) => ({
                ...prev,
                resuscitation: e.target.value,
              }));
            }}
            input={<OutlinedInput label="Resuscitation" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {resuscitationValues.map((name) => (
              <MenuItem key={name} value={name} sx={{ width: 400 }}>
                <Checkbox checked={birth.resuscitation.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label={"Congenital Anomaly"}
          type={"text"}
          size="small"
          select
          name={"congenitalAnomaly"}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                isCongenitalAnomaly: true,
              }));
              setBirth((prevBirth) => ({
                ...prevBirth,
                congenitalAnomaly: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                isCongenitalAnomaly: false,
              }));
              setBirth((prevBirth) => ({
                ...prevBirth,
                congenitalAnomaly: "no",
              }));
            }
          }}
          value={toggle.isCongenitalAnomaly ? "yes" : "no"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.isCongenitalAnomaly && (
          <TextField
            name={"congenitalAnomaly"}
            type={"text"}
            size="small"
            label={"Specify Congenital Anomaly"}
            className={""}
            value={birth.congenitalAnomaly}
            onChange={(e) => {
              const value = cleanEnglishOnly(e.target.value);
              setBirth((prevBirth) => ({
                ...prevBirth,
                congenitalAnomaly: value,
              }));
            }}
          />
        )}
        <NumberInput
          name="birthWeight"
          label="Birth Weight in kg (e.g.,3.50)"
          value={birth.birthWeight}
          onChange={handleBirthChange}
        />
        <NumberInput
          name="birthLength"
          label="Birth Length in cm (e.g., 50.00)"
          value={birth.birthLength}
          onChange={handleBirthChange}
        />
        <NumberInput
          name="birthHeadCircumference"
          label="Birth Head Circumference in cm"
          value={birth.birthHeadCircumference}
          onChange={handleBirthChange}
        />
        <NumberInput
          name="gestationalAge"
          label="Gestational Age in weeks"
          value={birth.gestationalAge}
          size="small"
          onChange={handleBirthChange}
          slotProps={{
            input: {
              readOnly: antenatal?.edd,
            },
          }}
        />
        <TextField
          name={"birthTrauma"}
          type={"text"}
          select
          size="small"
          label={"Birth Trauma"}
          className={""}
          value={toggle.birthTrauma ? "yes" : "no"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                birthTrauma: true,
              }));
              setBirth((prevBirth) => ({
                ...prevBirth,
                birthTrauma: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                birthTrauma: false,
              }));
              setBirth((prevBirth) => ({
                ...prevBirth,
                birthTrauma: "no",
              }));
            }
          }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.birthTrauma && (
          <TextField
            name={"birthTrauma"}
            type={"text"}
            size="small"
            label={"Specify Birth Trauma"}
            className={""}
            onChange={(e) => {
              const value = cleanEnglishOnly(e.target.value);
              setBirth((prevBirth) => ({
                ...prevBirth,
                birthTrauma: value,
              }));
            }}
            value={birth.birthTrauma}
          />
        )}

        <TextField
          name={"others"}
          type={"text"}
          size="small"
          label={"Other birth comments if any"}
          className={""}
          value={birth.others}
          onChange={handleBirthChange}
        />
      </div>
    </div>
  );

  let neonatalForm = (
    <div className={"cargiverFormCard"}>
      <h2 className="cardHeader">Neonatal Period</h2>
      <div className={"caregiverDiveder two-items"}>
        {/* Value is not showing after selection */}
        {/* <TextField
          isMultipleSelect
          type={"text"}
          required
          select
          size="small"
          label={"Neonatal Problems"}
          name={"neonatalProblems"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(values) => {
            setNeonatal((prevNeonatal) => ({
              ...prevNeonatal,
              neonatalProblems: values,
            }));
          }}
          value={neontal.neonatalProblems}
        >
          {neonatalProblemsOptionValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField> */}
        <FormControl
          size="small"
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          <InputLabel id="tone">Neonatal Problems</InputLabel>
          <Select
            labelId="Neonatal Problems"
            id="Neonatal Problems"
            multiple
            value={neontal.neonatalProblems}
            onChange={(e) => {
              setNeonatal((prev) => ({
                ...prev,
                neonatalProblems: e.target.value,
              }));
            }}
            input={<OutlinedInput label="Neonatal Problems" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {neonatalProblemsOptionValues.map((name) => (
              <MenuItem key={name} value={name} sx={{ width: 400 }}>
                <Checkbox checked={neontal.neonatalProblems.includes(name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label={"Hospitalization"}
          type={"text"}
          select
          size="small"
          name={"hospitalization"}
          onChange={handleNeonatalChange}
          value={neontal.hospitalization}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {hospitalizationValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );

  let familyForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Family History</h2>
      <div className={"familyDiveder"}>
        <TextField
          type={"text"}
          name={"anyHistoryofIllness"}
          select
          size="small"
          label={"Any history of illness or death in Sibling ?"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                anyHistoryofIllness: true,
              }));
              setFamily((prevBirth) => ({
                ...prevBirth,
                anyHistoryofIllness: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                anyHistoryofIllness: false,
              }));
              setFamily((prevBirth) => ({
                ...prevBirth,
                anyHistoryofIllness: "no",
              }));
            }
          }}
          value={toggle.anyHistoryofIllness ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.anyHistoryofIllness && (
          <TextField
            name={"anyHistoryofIllness"}
            type={"text"}
            label="Specify any history of illness or death"
            size="small"
            className={""}
            value={family.anyHistoryofIllness}
            onChange={handleFamilyChange}
          />
        )}
        <TextField
          type={"text"}
          name={"anyBehaviouralProblem"}
          select
          size="small"
          label={"Any behavioural problem in the family?"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                anyBehaviouralProblem: true,
              }));
              setFamily((prevBirth) => ({
                ...prevBirth,
                anyBehaviouralProblem: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                anyBehaviouralProblem: false,
              }));
              setFamily((prevBirth) => ({
                ...prevBirth,
                anyBehaviouralProblem: "no",
              }));
            }
          }}
          value={toggle.anyBehaviouralProblem ? "yes" : "no"}
          options={yesNoOptions}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.anyBehaviouralProblem && (
          <TextField
            name={"anyBehaviouralProblem"}
            label="Specify any behavioural problem in family"
            type={"text"}
            size="small"
            className={""}
            value={family.anyBehaviouralProblem}
            onChange={handleFamilyChange}
          />
        )}
        <TextField
          type={"text"}
          name={"disabilityInTheFamily"}
          size="small"
          select
          label={"Any disability in the family ?"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                disabilityInTheFamily: true,
              }));
              setFamily((prevBirth) => ({
                ...prevBirth,
                disabilityInTheFamily: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                disabilityInTheFamily: false,
              }));
              setFamily((prevBirth) => ({
                ...prevBirth,
                disabilityInTheFamily: "no",
              }));
            }
          }}
          value={toggle.disabilityInTheFamily ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.disabilityInTheFamily && (
          <TextField
            name={"disabilityInTheFamily"}
            label="Specify any disability in family"
            type={"text"}
            size="small"
            className={""}
            value={family.disabilityInTheFamily}
            onChange={handleFamilyChange}
          />
        )}
      </div>
    </div>
  );

  let feedingForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Feeding Information</h2>
      <div className={"caregiverDiveder"}>
        <TextField
          name={"breastFeeding"}
          value={feeding.breastFeeding}
          type={"text"}
          select
          size="small"
          label={"Breast Feeding"}
          onChange={handleFeedingChange}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {breastFeedingValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <NumberInput
          name={"noOfFeeds"}
          value={feeding.noOfFeeds}
          label={"No. of feeds or meals per day"}
          onChange={handleFeedingChange}
        />
        <TextField
          name={"solidFood"}
          value={feeding.solidFood}
          type={"text"}
          select
          size="small"
          label={"Solid Food or Semi-solids"}
          className={""}
          onChange={handleFeedingChange}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {breastFeedingValues.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );

  let presentForm = (
    <div className={"cargiverFormCard"}>
      <h2 className={"cardHeader"}>Present Health Status</h2>
      <div className={"presentDiveder"}>
        <TextField
          className="text"
          type="text"
          size="small"
          name="currentAge"
          label={
            present.currentAge === "" || present.currentAge === 0
              ? "Actual age in days"
              : "Actual age in months"
          }
          value={
            present.currentAge === "" || present.currentAge === 0
              ? `${present?.presentAgeInDays} Days`
              : present?.currentAge
          }
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        {present?.currentAge <= 24 && (
          <TextField
            name="adjustedAge"
            label={
              (present.gestationalAgeInMonths === "" ||
                present.gestationalAgeInMonths === 0) &&
              (present.gestationalAgeInDays !== "" || present.currentAge === 0)
                ? "Adjusted age in days"
                : "Adjusted age in months"
            }
            size="small"
            value={
              present.gestationalAgeInDays !== ""
                ? // && present.gestationalAgeInDays !== 0
                  present.gestationalAgeInMonths === "" ||
                  present.gestationalAgeInMonths === 0
                  ? `${present.gestationalAgeInDays} Days`
                  : present.gestationalAgeInMonths
                : "N/A"
            }
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        )}
        <NumberInput
          label="Weight in kg (e.g. 4)"
          name="currentWeight"
          value={present.currentWeight}
          onChange={handlePresentChange}
        />
        <NumberInput
          label="Length in cm (e.g. 50)"
          name="currentLength"
          value={present.currentLength}
          onChange={handlePresentChange}
        />
        <NumberInput
          label="Head Circumference in c.m (e.g. 40)"
          name="currentHeadCircumference"
          value={present.currentHeadCircumference}
          onChange={handlePresentChange}
        />
      </div>
      <div className={"caregiverDiveder"}>
        <TextField
          className="item"
          label={"Immunization"}
          type={"text"}
          select
          size="small"
          name={"immunization"}
          onChange={handlePresentChange}
          value={present.immunization}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {immunizationValue.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          type={"text"}
          name={"chronicIllness"}
          select
          size="small"
          label={"Chronic Illness "}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                chronicIllness: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                chronicIllness: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                chronicIllness: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                chronicIllness: "no",
              }));
            }
          }}
          value={toggle.chronicIllness ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.chronicIllness && (
          <TextField
            name={"chronicIllness"}
            type={"text"}
            size="small"
            label="Specify Chronic Illness"
            className={""}
            value={present.chronicIllness}
            onChange={handlePresentChange}
          />
        )}
      </div>
      <div className={"caregiverDiveder two-items"}>
        <TextField
          type={"text"}
          name={"growthFaltering"}
          select
          size="small"
          label={"Growth Faltering"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                growthFaltering: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                growthFaltering: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                growthFaltering: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                growthFaltering: "no",
              }));
            }
          }}
          value={toggle.growthFaltering ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {toggle.growthFaltering && (
          <TextField
            name={"growthFaltering"}
            type={"text"}
            size="small"
            label="Specify Growth Faltering"
            className={""}
            onChange={handlePresentChange}
            value={present.growthFaltering}
          />
        )}
        <TextField
          type={"text"}
          select
          size="small"
          label={"Delayed Development Cognitive"}
          name={"delayedDevelopmentCognitive"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                delayedDevelopmentCognitiveSocial: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                delayedDevelopmentCognitive: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                delayedDevelopmentCognitiveSocial: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                delayedDevelopmentCognitive: "no",
              }));
            }
          }}
          value={toggle.delayedDevelopmentCognitiveSocial ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.delayedDevelopmentCognitiveSocial && (
          <TextField
            name={"delayedDevelopmentCognitive"}
            type={"text"}
            size="small"
            label="Specify Delayed Development Cognitive"
            className={""}
            value={present.delayedDevelopmentCognitive}
            onChange={handlePresentChange}
          />
        )}
        <TextField
          type={"text"}
          select
          size="small"
          label={"Delayed Development Motor"}
          name={"delayedDevelopmentMotor"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                delayedDevelopmentMotor: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                delayedDevelopmentMotor: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                delayedDevelopmentMotor: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                delayedDevelopmentMotor: "no",
              }));
            }
          }}
          value={toggle.delayedDevelopmentMotor ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.delayedDevelopmentMotor && (
          <TextField
            name={"delayedDevelopmentMotor"}
            type={"text"}
            size="small"
            label="Specify Delayed Development Motor"
            className={""}
            onChange={handlePresentChange}
            value={present.delayedDevelopmentMotor}
          />
        )}
        <TextField
          type={"text"}
          size="small"
          select
          label="Delayed Development Language "
          name={"delayedDevelopmentLanguage"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                delayedDevelopmentLanguage: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                delayedDevelopmentLanguage: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                delayedDevelopmentLanguage: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                delayedDevelopmentLanguage: "no",
              }));
            }
          }}
          value={toggle.delayedDevelopmentLanguage ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.delayedDevelopmentLanguage && (
          <TextField
            name={"delayedDevelopmentLanguage"}
            type={"text"}
            size="small"
            label="Specify Delayed Development Language"
            className={""}
            onChange={handlePresentChange}
            value={present.delayedDevelopmentLanguage}
          />
        )}
        <TextField
          type={"text"}
          label={"Atypical Behaviour"}
          select
          size="small"
          name={"atypicalBehaviour"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                atypicalBehaviour: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                atypicalBehaviour: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                atypicalBehaviour: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                atypicalBehaviour: "no",
              }));
            }
          }}
          value={toggle.atypicalBehaviour ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.atypicalBehaviour && (
          <TextField
            name={"atypicalBehaviour"}
            type={"text"}
            size="small"
            label="Specify Atypical Behaviour"
            className={""}
            onChange={handlePresentChange}
            value={present.atypicalBehaviour}
          />
        )}
      </div>
      <div className={"caregiverDiveder"}>
        <TextField
          label={"Convulsions"}
          type={"text"}
          select
          size="small"
          name={"convulsions"}
          onChange={handlePresentChange}
          value={present.convulsions}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          type={"text"}
          select
          label={"Dysmorphism"}
          size="small"
          name={"dysmorphism"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                dysmorphism: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                dysmorphism: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                dysmorphism: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                dysmorphism: "no",
              }));
            }
          }}
          value={toggle.dysmorphism ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.dysmorphism && (
          <TextField
            name={"dysmorphism"}
            type={"text"}
            size="small"
            label="Specify Dysmorphism"
            className={""}
            onChange={handlePresentChange}
            value={present.dysmorphism}
          />
        )}
        <TextField
          type={"text"}
          select
          size="small"
          label={"Any Systemic Illness "}
          placeholder={"Any Systemic Illness "}
          name={"anySystemicIllness"}
          sx={{ backgroundColor: "#3071FF21", height: "40px" }}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "yes") {
              setToggle((prevToggle) => ({
                ...prevToggle,
                anySystemicIllness: true,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                anySystemicIllness: "",
              }));
            } else {
              setToggle((prevToggle) => ({
                ...prevToggle,
                anySystemicIllness: false,
              }));
              setPresent((prevBirth) => ({
                ...prevBirth,
                anySystemicIllness: "no",
              }));
            }
          }}
          value={toggle.anySystemicIllness ? "yes" : "no"}
        >
          {yesNoOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {toggle.anySystemicIllness && (
          <TextField
            name={"anySystemicIllness"}
            type={"text"}
            size="small"
            label="Specify Any Systemic Illness"
            className={""}
            onChange={handlePresentChange}
            value={present.anySystemicIllness}
          />
        )}
        <TextField
          type="text"
          name="presentOthers"
          value={present.presentOthers}
          size="small"
          label="Any other comments"
          onChange={handlePresentChange}
        />
      </div>
    </div>
  );

  return (
    <div className={"patient-profile"}>
      <Loader isLoading={loading} />
      <div className="header-container">
        <div className="back-container" onClick={handleBack}>
          <button className="update-backButton">
            <FontAwesomeIcon className="icon" icon={faArrowLeft} />
          </button>

          <p className="back-text">Back to Patient Profile</p>
        </div>

        <h1>Update Patient</h1>
      </div>

      {step === PATIENTFORM.CAREGIVER && bodyContent}
      {step === PATIENTFORM.PATIENT && patientForm}
      {step === PATIENTFORM.MATERNAL && maternalForm}
      {step === PATIENTFORM.ANTENATAL && antenatalForm}
      {step === PATIENTFORM.BIRTH && birthForm}
      {step === PATIENTFORM.NEONATAL && neonatalForm}
      {step === PATIENTFORM.FAMILY && familyForm}
      {step === PATIENTFORM.FEEDING && feedingForm}
      {step === PATIENTFORM.PRESENT && presentForm}
      <div className={"actionButtons"}>
        {secondaryActionLabel && (
          <button
            type="button"
            className={"secondaryActionButton"}
            onClick={decrementStep}
          >
            {secondaryActionLabel}
          </button>
        )}
        {actionLabel && (
          <button
            className={"submitButton"}
            onClick={incrementStep}
            type="button"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default UpdatePatient;
